import ErrorMessage from "components/shared/error-message/ErrorMessage";
import InputField from "components/shared/input-field/InputField";
import Pin from "components/shared/pin/Pin";
import GuiContext from "config/context/guiContext";
import ThemeContext from "config/context/themeContext";
import useCustomStyles from "config/useCustomStyles";
import { useContext, useState } from "react";
import Modal from "react-modal";
import styles from "./PinRecoveryModal.module.css";
import { initPinState } from "components/shared/pin/init-state";

const PinRecoveryModal = ({ isRecoveryModalOpen, setIsRecoveryModalOpen }) => {
  const [userWordCombination, setUserWordCombination] = useState(
    Array(12).fill(""),
  );
  const [guiName, setGuiName] = useState("");
  const [pin, setPin] = useState(initPinState);
  const [serverResponse, setServerResponse] = useState("");
  const [step, setStep] = useState(0);
  const { dark } = useContext(ThemeContext);
  const {
    URL,
    selected: { selectedServer },
  } = useContext(GuiContext);
  const customStyles = useCustomStyles();
  const handleResponseMessage = (message) => {
    setServerResponse(message);

    setTimeout(() => {
      setServerResponse("");
    }, 3000);
  };
  const handleGuiInput = (e) => {
    setGuiName(e.target.value);
  };
  const handleWordChange = (e) => {
    const updatedUserWordCombination = [...userWordCombination];
    updatedUserWordCombination[e.target.name.split("-")[1]] = e.target.value;
    setUserWordCombination(updatedUserWordCombination);
  };
  const closeModal = () => {
    setUserWordCombination(Array(12).fill(""));
    setPin(initPinState);
    setGuiName("");
    setStep(0);
    setIsRecoveryModalOpen(false);
  };

  const isFormValid = () => {
    const trimmedGuiName = guiName?.trim();
    const isPinComplete = Object.values(pin).every((val) => val !== "" && val !== null && val !== undefined);
    return trimmedGuiName && trimmedGuiName.length > 0 && isPinComplete;
  };

  const submitGuiName = () => {
    if (!isFormValid()) {
      handleResponseMessage("Please enter account name and pin code");
      return;
    }
    const url = `${URL}/api/inerygui/guiname_exists`;
    const data = {
      guiname: guiName,
      server_url: selectedServer,
    };
    const sendData = async () => {
      try {
        const res = await fetch(url, {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify(data),
        });
        const response = await res.json();
        if (response) {
          setStep(1);
        } else {
          handleResponseMessage("Account name is incorrect");
        }
      } catch (err) {
        console.error(err);
      }
    };
    sendData();
  };

  const handleRecoverPinCode = () => {
    if (userWordCombination.includes("")) {
      handleResponseMessage(
        "Please fill in all required fields. At least one field is empty.",
      );
      return;
    }
    const url = `${URL}/api/inerygui/recover_pincode`;
    const data = {
      guiname: guiName,
      pincode: Object.values(pin).join(""),
      words: userWordCombination,
      server_url: selectedServer,
    };
    const sendData = async () => {
      try {
        const res = await fetch(url, {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify(data),
        });
        const response = await res.json();
        if (res.ok) {
          setStep(3);

          setTimeout(() => {
            closeModal();
          }, 3000);
        } else {
        }
        handleResponseMessage(response.message);
      } catch (err) {
        console.error(err);
      }
    };
    sendData();
  };

  return (
    <Modal
      isOpen={isRecoveryModalOpen}
      ariaHideApp={false}
      style={customStyles}
      contentLabel="Pin Recovery Modal"
    >
      <section className={`${styles.pinRecovery} ${dark ? styles.dark : ""}`}>
        {step === 0 && (
          <div className={styles.inputControl}>
            <div className={styles.container}>
              <h2>Change PIN Code</h2>
            </div>
            <div className={styles.container}>
              <label>Account name</label>
              <InputField
                required
                value={guiName}
                onChange={handleGuiInput}
                type="text"
                placeholder="Enter your account name"
              />
            </div>
            <div className={styles.container}>
              <label htmlFor="pin">New PIN code</label>
              <Pin
                value={pin}
                onChange={setPin}
                className={styles.hideOrShowPasswordButton}
              />
            </div>
            <div className={styles.btn_row}>
              <button 
                onClick={submitGuiName} 
                expand="full"
                disabled={!isFormValid()}
              >
                Next
              </button>
              <button
                onClick={closeModal}
                type="button"
              >
                Cancel
              </button>
            </div>
            <ErrorMessage value={serverResponse} />
          </div>
        )}

        {step === 1 && (
          <div>
            <div className={styles.introText}>
              <p>
                To verify that your data is not compromised, please fill in your
                own 12 word pattern in the fields bellow
              </p>
            </div>
            <div className={styles.wordInput}>
              {userWordCombination.map((a, index) => (
                <InputField
                  key={index}
                  placeholder={index + 1}
                  id={`word-${index}`}
                  name={`word-${index}`}
                  value={userWordCombination[index]}
                  onChange={handleWordChange}
                />
              ))}
            </div>
            <ErrorMessage value={serverResponse} />
            <div className={styles.btn_row}>
              <button onClick={handleRecoverPinCode}>Change PIN Code</button>
              <button
                type="button"
                onClick={closeModal}
              >
                Cancel
              </button>
            </div>
          </div>
        )}
        {step === 3 && <p>{serverResponse}</p>}
      </section>
    </Modal>
  );
};

export default PinRecoveryModal;
